export enum CharacterAnimations {
  ENCOURAGE = 'Encourage',
  IDLE_1 = 'Idle1',
  IDLE_2 = 'Idle2',
  WIN = 'Win',
  LOSE = 'Lose',
  SLEEPY = 'Sleeppy',
  WAKE_UP = 'WakeUp',
  YAWN_TO_IDLE_1 = 'YawnToIdle1',
  YAWN_TO_SLEEPY = 'YawnToSleepy',
}

export const CHARACTER_ANIMATION_JSON = '/animation/tigerAnim.json';
export const CHARACTER_ANIMATION_ATLAS = '/animation/tigerAnim.atlas';
